import axios from 'axios'
import { PageDataResponse ,PageResponse ,DataArrayResponse} from '../models/PageResponse'
import { Country,DeleteData }  from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL

export default class CountryService
{
    protected headers = {}
    protected token = ""

    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        }
    }
    
    async getAll(page: number,limit: number,key:string){
        let options = {
                headers: this.headers,
                params: {
                    page: page,
                    limit: limit,
                    key: key
                }
            }
        
        const { data }  = await axios.get<PageDataResponse<Country>>(`${apiUrl}/v1/countries/call`, options )
        
        return data;
    }

    async getAllActive(){
        let options = {
                headers: this.headers
            }
        
        const { data }  = await axios.get<DataArrayResponse<Country>>(`${apiUrl}/v1/countries/active`, options )
        
        return data;
    }

    async search(key:string){
        let options = {
            headers:this.headers,
            params: {
                key: encodeURI(key)
            }
        }
        const { data }   = await axios.get<DataArrayResponse<Country>>(`${apiUrl}/v1/countries/search`,options )
        return data;
    }

    async create(country: Country){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/countries/call`,JSON.stringify(country),options )
        return data;
    }

    async update(country: Country){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/countries/call`,JSON.stringify(country),options )
        return data;
    }

    async updateStatus(country: Country){
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/countries/status`,JSON.stringify(country),options )
        return data;
    }

    async delete(id: number,updateBy: string){
        if(!this.token) return null
        
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers
        }
        let deleteData:DeleteData = {
            id:id,
            updateBy:updateBy
        }
        const { data }  = await axios.post<PageResponse>(`${apiUrl}/v1/countries/delete`,JSON.stringify(deleteData),options )
        return data;
    }
}